(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["menu-horizontal"] && !Shopify.designMode) return;
  try {
    (function () {
    const TAB_ANIM_MS = 100;

    function initSubCollectionTabs() {
      const root = document.querySelector('[data-sub-collection-tabs]');
      if (!root) return;
      const results = document.getElementById('ResultsList');
      if (!results || !results.classList.contains('main-collection__sub-collections')) return;
      const groups = Array.from(
        results.querySelectorAll('.main-collection__sub-collection-group[data-sub-collection-handle]'),
      );
      if (!groups.length) return;

      const tabs = root.querySelectorAll('[data-sub-collection-tab]');
      if (!tabs.length) return;

      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      let isAnimating = false;

      function endOpacityTransition(el, finish) {
        const done = () => finish();
        el.addEventListener(
          'transitionend',
          (e) => {
            if (e.propertyName !== 'opacity') return;
            done();
          },
          { once: true },
        );
        window.setTimeout(done, TAB_ANIM_MS);
      }

      function fadeOut(el) {
        if (el.hidden) return Promise.resolve();
        return new Promise((resolve) => {
          if (prefersReducedMotion) {
            el.hidden = true;
            resolve();
            return;
          }
          let finished = false;
          const finish = () => {
            if (finished) return;
            finished = true;
            el.hidden = true;
            el.style.removeProperty('opacity');
            el.style.removeProperty('transition');
            resolve();
          };
          el.style.transition = `opacity ${TAB_ANIM_MS}ms ease-out`;
          el.style.opacity = '0';
          endOpacityTransition(el, finish);
        });
      }

      function fadeIn(el) {
        if (!el.hidden) return Promise.resolve();
        return new Promise((resolve) => {
          if (prefersReducedMotion) {
            el.hidden = false;
            resolve();
            return;
          }
          let finished = false;
          const finish = () => {
            if (finished) return;
            finished = true;
            el.style.removeProperty('opacity');
            el.style.removeProperty('transition');
            resolve();
          };
          el.hidden = false;
          el.style.opacity = '0';
          el.style.transition = 'none';
          void el.offsetHeight;
          el.style.transition = `opacity ${TAB_ANIM_MS}ms ease-out`;
          requestAnimationFrame(() => {
            el.style.opacity = '1';
            endOpacityTransition(el, finish);
          });
        });
      }

      /** Only when switching from “All” to a sub — selected row was already visible. */
      function forceRevealFade(el) {
        if (prefersReducedMotion) return Promise.resolve();
        return new Promise((resolve) => {
          let finished = false;
          const finish = () => {
            if (finished) return;
            finished = true;
            el.style.removeProperty('opacity');
            el.style.removeProperty('transition');
            resolve();
          };
          el.style.transition = 'none';
          el.style.opacity = '0';
          void el.offsetHeight;
          el.style.transition = `opacity ${TAB_ANIM_MS}ms ease-out`;
          requestAnimationFrame(() => {
            el.style.opacity = '1';
            endOpacityTransition(el, finish);
          });
        });
      }

      async function activateTab(selected) {
        if (isAnimating) return;
        if (selected.getAttribute('aria-selected') === 'true') return;

        const handle = selected.getAttribute('data-sub-collection-tab');
        tabs.forEach((tab) => {
          const isSel = tab === selected;
          tab.setAttribute('aria-selected', isSel ? 'true' : 'false');
          tab.tabIndex = isSel ? 0 : -1;
        });

        if (prefersReducedMotion) {
          if (handle === 'all') {
            groups.forEach((g) => {
              g.hidden = false;
            });
          } else {
            groups.forEach((g) => {
              g.hidden = g.getAttribute('data-sub-collection-handle') !== handle;
            });
          }
          return;
        }

        isAnimating = true;
        try {
          if (handle === 'all') {
            const hidden = groups.filter((g) => g.hidden);
            await Promise.all(hidden.map((g) => fadeIn(g)));
          } else {
            const toHide = [];
            const toShow = [];
            groups.forEach((g) => {
              const gh = g.getAttribute('data-sub-collection-handle');
              if (gh !== handle && !g.hidden) toHide.push(g);
              if (gh === handle && g.hidden) toShow.push(g);
            });
            const selectedEl = groups.find(
              (g) => g.getAttribute('data-sub-collection-handle') === handle,
            );
            const needRevealOnly =
              Boolean(selectedEl && !selectedEl.hidden && toShow.length === 0);

            const parallel = toHide.map((g) => fadeOut(g));
            if (needRevealOnly) {
              parallel.push(forceRevealFade(selectedEl));
            }
            await Promise.all(parallel);
            await Promise.all(toShow.map((g) => fadeIn(g)));
          }
        } finally {
          isAnimating = false;
        }
      }

      tabs.forEach((tab) => {
        tab.addEventListener('click', () => activateTab(tab));
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initSubCollectionTabs, { once: true });
    } else {
      initSubCollectionTabs();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
